// extracted by mini-css-extract-plugin
module.exports = {"container":"region-card_container___ZQDI"};